<template>
  <div class="d-flex flex-column flex-md-row col-md-5 mx-auto text-center">
    <v-list-item class="mx-auto">
      <v-list-item-icon class="mx-1">
        <v-icon>mdi-email</v-icon>
      </v-list-item-icon>
      <v-list-item-title>
        <a
          target="_top"
          href="mailto:stiven10@gmail.com"
        >stiven10@gmail.com</a>
      </v-list-item-title>
    </v-list-item>
    <v-list-item class="mx-auto">
      <v-list-item-icon class="mx-1">
        <v-icon>mdi-linkedin</v-icon>
      </v-list-item-icon>
      <v-list-item-title><a href="https://www.linkedin.com/in/johanstiventinjaca/">LinkedIn</a></v-list-item-title>
    </v-list-item>
    <v-list-item class="mx-auto">
      <v-list-item-icon class="mx-1">
        <v-icon>mdi-github-circle</v-icon>
      </v-list-item-icon>
      <v-list-item-title><a href="https://github.com/jstiven01">GitHub</a></v-list-item-title>
    </v-list-item>
  </div>
</template>

<script>
export default {
    
}
</script>